/* src/app/modules/dna-syngovia/components/dna-syngovia-healthcheck-issues-table/dna-syngovia-healthcheck-issues-table.component.scss */
:host {
  display: block;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
}
.header .header-info {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.header .header-info .issues-date {
  text-align: right;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
}
.header sh-text {
  width: fit-content;
}
.search-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.search-container sh-input-text {
  width: 15.25rem;
}
.search-container sh-icon[icon=filter] {
  color: rgb(var(--ui-5));
  cursor: pointer;
}
.search-container .dropdown-score {
  width: 11.25rem;
}
.icon-counter-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.25rem;
}
.table-container {
  overflow-x: auto;
}
.table {
  width: 100%;
  min-width: fit-content;
}
.table-fixed-height {
  height: 34.0625rem;
}
.description div {
  width: 100%;
  max-width: 20.3125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ticket-table-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 5rem;
  max-width: 5rem;
}
.ticket-button {
  border: 1px solid rgba(var(--ui-1), var(--opacity-5));
  border-radius: 100%;
  background: none;
  display: flex;
  width: 2rem;
  height: 2rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ticket-button img {
  width: 1.75rem;
  height: 1.125rem;
  opacity: 60%;
}
.ticket-button:hover {
  background: rgba(0, 0, 0, 0.1);
}
.ticket-button:hover img {
  opacity: 100%;
}
.ticket-text {
  color: var(--text-secondary);
}
.score-severity {
  width: 4.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(var(--ui-1), var(--opacity-2));
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.75rem;
}
.score-severity--low {
  border: 1px solid rgb(var(--functional-green));
  background-color: rgba(0, 154, 56, 0.03);
}
.score-severity--medium {
  border: 1px solid rgb(var(--functional-yellow));
  background-color: rgba(255, 210, 0, 0.03);
}
.score-severity--high {
  border: 1px solid rgb(var(--functional-red));
  background: rgba(231, 0, 29, 0.03);
}
.description-container {
  max-width: 44rem;
  padding: 1rem 1rem 2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.header-description {
  font-weight: 700;
  line-height: 1.75rem;
}
.detailed-description {
  font-weight: 400;
  line-height: 1.5rem;
}
.tag-container {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding-top: 0.5rem;
}
.tag-container sh-tag {
  background-color: rgba(241, 158, 106, var(--opacity-3));
}
/*# sourceMappingURL=dna-syngovia-healthcheck-issues-table.component.css.map */
